import { defineComponent as _defineComponent } from 'vue'
import { Ref, reactive, ref } from 'vue';
import { AxiosError } from 'axios';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import CButton from '@/components/shared/CButton';
import CInput from '@/components/shared/CInput';
import CLoader from '@/components/shared/CLoader.vue';
import CRecaptcha, { CRecaptchaRef } from '@/components/shared/CRecaptcha';
import { registerAffiliate } from '@/api/user';
import { useLoader } from '@/composables/loader';
import { toRegistrationErrorMessage } from './registrationError';
import CustomilyImg from '@/assets/images/customily-logo.png';


export default /*#__PURE__*/_defineComponent({
  __name: 'AffiliateSignUp',
  setup(__props) {

const form = reactive({
    name: '',
    username: '',
    email: '',
    password: '',
    passwordConfirmation: '',
    captchaToken: ''
});

const registered = ref(false);
const errorMessage = ref('');
const recaptcha: Ref<CRecaptchaRef | undefined> = ref();

const { display, isLoading, loaderText } = useLoader();

const signUp = async () => {
    errorMessage.value = '';
    display(true, 'Creating your account...');

    try {
        await registerAffiliate({
            Name: form.name,
            Username: form.username,
            Email: form.email,
            Password: form.password,
            ConfirmationPassword: form.passwordConfirmation,
            Captcha: form.captchaToken
        });

        registered.value = true;
    } catch (error) {
        recaptcha.value?.reset();
        errorMessage.value = toRegistrationErrorMessage(error as AxiosError);
    } finally {
        display(false);
    }
};

return { __sfc: true,form, registered, errorMessage, recaptcha, display, isLoading, loaderText, signUp, ValidationObserver, ValidationProvider, CButton, CInput, CLoader, CRecaptcha, CustomilyImg }
}

})